import axios from "axios";
import { toast } from "react-toastify";
import { fetchCustomerAddress } from "../redux/actions/customerAddress";
import { useDispatch } from "react-redux";

const Base_Url = process.env.REACT_APP_BASE_URL;
export default function DeleteAddressModel({ isOpen, onClose ,id}) {
  const dispatch=useDispatch();
  if (!id) return null;
  if (!isOpen) return null;
  
  const handleYesClick = async() => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.delete(
        `${Base_Url}/api/address/deleteAddress/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.data.success) {
        toast.success(res.data.message||"Address deleted successfully..")
      } else {
        toast.error(res.data.message || "Failed to add address");
      } 
      dispatch(fetchCustomerAddress());  
      onClose();
    } catch (err) 
    {
      console.error("❌ Fetch delete error:", err);
      toast.error(err.response?.data?.message || "Failed to delete address");
    }
  };

  return (
    <div className="fixed inset-0 z-100 flex items-center justify-center bg-black bg-opacity-40 p-2">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-xs p-2 md:p-6">
        <h2 className="text-sm md:text-base xl:text-lg font-semibold mb-4 text-black">Are you sure to delete this address?</h2>

        <div className="flex justify-end space-x-4 text-sm md:text-base xl:text-lg">
          <button
            onClick={onClose}
            className="px-4 py-1 md:py-1 bg-gray-300 rounded hover:bg-gray-400"
          >
            No
          </button>
          <button
            onClick={handleYesClick}
            className="px-4 py-1 md:py-1 bg-[#A63F40] text-white rounded hover:bg-[#722425]"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
}
